import script from "./LoginDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginDashboard.vue?vue&type=script&setup=true&lang=js"

import "./LoginDashboard.vue?vue&type=style&index=0&id=5c95302e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c95302e"]])

export default __exports__